
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { isDifferent, isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import { RootState } from '@/store/store';
import { Action, State } from 'vuex-class';
import { AxiosError } from 'axios';
import { get as _get } from 'lodash';

export interface InviteUserFormValues {
  email?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
}

// Define component methods interface
interface ComponentMethods {
  handleEmailInput(): void;
}

const initialFormValue = {
  email: '',
  username: '',
  firstName: '',
  lastName: ''
};

@Component({
  components: {
    ValidationProvider
  }
})
export default class InviteUserForm extends Vue implements ComponentMethods {
  public form: InviteUserFormValues = {
    ...initialFormValue
  };

  @State((state: RootState) => state.users.apiState.inviteNewUser.success)
  public inviteNewUserSuccess!: boolean;

  public handleEmailInput(): void {
    // Manually trigger validation on input to update button state
    const emailProvider = this.$refs.emailProvider as any;
    if (emailProvider) {
      emailProvider.validate();
    }
  }

  public handleSubmit() {
    if (!this.form.email) {
      return;
    }
    this.$emit('submit', this.form);
  }

  public focusEmailInput() {
    const emailInput = this.$refs.emailInput as HTMLInputElement;
    if (emailInput) {
      emailInput.focus();
    }
  }

  @Watch('inviteNewUserSuccess')
  @isDifferent
  @isTruthy
  public watchInviteUserSuccess() {
    this.$emit('closeModal');
  }
}
